export default __webpack_public_path__ + "static/media/plain-sticker-us.d885ec9d.png";